export const environment = {
    production: false,
    apiUrl: 'https://dev-smp.us-east-2.service.3ddvfactory.com/bo',
    routes: true, // Enable Tracing debug angular routes
    takeOverUrl: 'https://dev-lagalaxy.3ddigitalvenue.com/'
  };
